import { SalesOrderDTO, SalesOrderType } from 'core/api';

// Necesito un model para ajustar algunas cosas (como el Address, que no quiero pintarlo si es TakeAway )
export type SalesOrderModel = SalesOrderDTO & {
	DeliveryAddressSummary: string
};

export function toModel(order: SalesOrderDTO): SalesOrderModel {
	return {
		...order,
		DeliveryAddressSummary: order.Type === SalesOrderType.Delivery ? order.AddressSummary : ''
	};
}